import React from "react";
import SvgIcon from "@mui/material/SvgIcon";

const LeafSvg = () => (
    <SvgIcon
        sx={{
            position: "absolute",
            top: "-2px",
            right: "-8px",
            transform: "translate(24%, -24%)"
        }}
    >
        <path
            d="M5.16854 20.1994L5.98516 18.3211C6.30297 18.4123 6.62945 18.4717 6.95981 18.4984L6.97987 18.5H7C12.8 18.5 16.4271 14.0138 18.5722 9.72361C19.6529 7.56229 20.3817 5.40593 20.8403 3.79299C21.0699 2.98558 21.2323 2.31206 21.3377 1.83915C21.3903 1.60265 21.4287 1.41617 21.4541 1.28805C21.4668 1.22399 21.4762 1.1745 21.4825 1.14063L21.4897 1.10166L21.4916 1.0912L21.4921 1.08827L21.4923 1.08739C21.4924 1.08711 21.4924 1.08689 21 1L21.4924 1.08689L20.5528 0.776393C20.3958 1.09033 19.9401 1.42587 19.0781 1.74141C18.2462 2.04596 17.1568 2.28997 15.9138 2.50748C14.8448 2.69456 13.6832 2.85866 12.499 3.02596C12.3097 3.0527 12.1198 3.07952 11.9297 3.10653C10.5551 3.30178 9.16736 3.50663 7.90194 3.75971C5.27288 4.28552 3.42204 5.67028 2.23125 7.19185C1.05238 8.69818 0.5 10.3662 0.5 11.5V11.5244L0.502375 11.5487C0.651715 13.0754 1.31888 14.505 2.39305 15.6001L2.95548 16.1735L3.22173 15.4157C4.57597 11.5614 7.14115 9.37737 9.62978 8.13444C8.3392 9.02769 7.29366 10.0592 6.42136 11.173C4.62676 13.4644 3.57752 16.0941 2.62335 18.4855C2.53362 18.7104 2.44473 18.9332 2.35613 19.1534L2.16062 19.6393L2.65516 19.812L4.54516 20.472L4.98343 20.6251L5.16854 20.1994Z"
            fill="#52A300"
            stroke="white"
        />
    </SvgIcon>
);

export default LeafSvg;
